import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'
import { Toaster } from 'sonner'
import { router } from './router'
import { initSentry, SentryErrorBoundary, ErrorFallback } from '@/lib/sentry'
import './index.css'

// 初始化 Sentry（必须在 render 前执行）
initSentry()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <SentryErrorBoundary fallback={<ErrorFallback />}>
      <RouterProvider router={router} />
      <Toaster richColors position="top-center" />
    </SentryErrorBoundary>
  </StrictMode>,
)

